<template>
  <div>
    <div style="margin-top: -30px">
      <div class="divider-custom-zalo mb-3"></div>
      <div class="d-flex flex-column justify-content-center align-items-center mb-3">
        <el-avatar :size="72" :src="avatar"></el-avatar>
        <div class="text-center font-size-16 fw-semibold mt-3 text-1-line mb-2 text-break" style="white-space: normal">
          {{ name }}
        </div>
        <div>
          <el-button class="text-center" type="primary" size="small" plain @click="toggleSendMessage">Nhắn tin</el-button>
        </div>
        <div v-if="showSendMessage" class="w-100 mt-3 px-3">
          <el-input
            v-model="messageText"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 5 }"
            placeholder="Nhập nội dung tin nhắn"
            resize="none"
            :disabled="sending"
            @keydown.enter.exact.native.prevent="sendQuickMessage" />
          <div class="d-flex justify-content-end mt-2 gap-2">
            <el-button size="mini" @click="toggleSendMessage" :disabled="sending">Hủy</el-button>
            <el-button
              size="mini"
              type="primary"
              :loading="sending"
              :disabled="sending || !messageText.trim()"
              @click="sendQuickMessage">
              Gửi
            </el-button>
          </div>
        </div>
      </div>
      <div class="divider-custom-zalo mt-3 mb-3"></div>

      <div class="py-2 d-flex pointer align-items-center  group_popup rounded-1 text-danger" @click="leaveGroup()">
        <img src="/assets/images/leave new.svg" width="14" height="13.6" class="mx-2">
        <div>Rời khỏi nhóm</div>
      </div>
      <div  @click="copy()" class="py-2 pointer group_popup align-items-center rounded-1 d-flex ">
        <i class="el-icon-link mx-2 pointer" />
        <div class="d-flex flex-column justify-content-around flex-1">
          <div>Link tham gia nhóm</div>
          <div style="color: #005ae0">{{ linkGroup }}</div>
        </div>
        <div class="copy me-3 p-2 " >
          <i class="el-icon-copy-document" />
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "GroupInfoPopup",
  props: {
    idConversationGroup: Object,
    avatar: String,
    name: String,
    members: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      linkGroup: "",
      showSendMessage: false,
      messageText: "",
      sending: false
    };
  },
  methods: {
    copy() {
      const el = document.createElement("textarea");
      el.value = this.linkGroup;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      this.alert("success", "Đã sao chép");
    },
    getLink() {
      let req = {
        accountId: this.idConversationGroup.accountId,
        groupId: this.idConversationGroup.toId
      };
      this.$http.post("/api/conversation/groupLink", req).then((resp) => {
        if (resp.data.error_code === 0) {
          this.linkGroup = resp.data.data.link;
        }
      });

    },
    closePopup() {
      this.$bus.$emit("closeGroupInfoPopup");
    },
    toggleSendMessage() {
      this.showSendMessage = !this.showSendMessage;
      if (!this.showSendMessage) this.messageText = "";
    },
    async sendQuickMessage() {
      const text = (this.messageText || "").trim();
      if (!text) return this.alert("error", "Nhập nội dung cần gửi.");
      if (!this.idConversationGroup) return;
      this.sending = true;
      try {
        await this.$http.post("/api/message/groupMsg", {
          accountId: this.idConversationGroup.accountId,
          groupId: this.idConversationGroup.toId,
          message: text
        });
        this.alert("success", "Đã gửi tin nhắn");
        this.messageText = "";
        this.showSendMessage = false;
      } catch (e) {
        this.alert("error", (e && e.error && e.error.message) || "Có lỗi xảy ra, vui lòng thử lại");
      } finally {
        this.sending = false;
      }
    },
    leaveGroup() {
      this.$http.get("/api/conversation/leaveGroup", {
        params: {
          groupId: this.idConversationGroup.toId,
          accountId: this.idConversationGroup.accountId
        }
      }).then((resp) => {
        if (resp.data?.error_message === "Successful.") {
          this.alert("success", "Rời nhóm thành công");
          this.$bus.$emit("leaveGroup", this.idConversationGroup);
        } else this.alert("error", "Có lỗi xảy ra, vui lòng thử lại");
      });
    }
  },
  mounted() {
    this.getLink();
  }
};
</script>

<style scoped>
.group_popup:hover {
  background-color: #eff2f7;
}
.copy:hover{
  color: #005ae0;
}
</style>